(function () {
    'use strict';

    run.admin.parts.tileDescription = function() {
        // Open descriptions
        document.addEventListener('click',function(e) {
            const info_button = e.target.closest(".description_indicator");
            if (!info_button) return;

            const tile = e.target.closest(".tool");
            const title_container = tile.querySelector('.tool__name');
            const desc_container = tile.querySelector('.tool__description');
            // console.log(desc_container.innerHTML);

            Swal.fire({
                title: title_container.innerHTML.trim(),
                html: nl2br(desc_container.innerHTML.trim()),
                showClass: {
                    popup: 'animate__animated animated__fast animate__fadeInUp'
                },
                hideClass: {
                    popup: 'animate__animated animated__fast animate__fadeOutDown'
                }
            })
        });

        // Open reason
        document.addEventListener('click',function(e) {
            const info_button = e.target.closest(".reason_indicator");
            if (!info_button) return;

            const tile = e.target.closest(".tool");
            const title_container = tile.querySelector('.tool__name');
            const desc_container = tile.querySelector('.tool__reason');
            // console.log(desc_container.innerHTML);

            let title = replaceAll(translations.tiles.suggest.reason_title, {
                '{name}': title_container.innerText.trim(),
            });

            Swal.fire({
                title: title,
                html: nl2br(desc_container.innerHTML.trim()),
                showClass: {
                    popup: 'animate__animated animated__fast animate__fadeInUp'
                },
                hideClass: {
                    popup: 'animate__animated animated__fast animate__fadeOutDown'
                }
            })
        });
    }
})();
